// Single source of truth for the public R2/CDN base URL.
// Set per-environment via `VITE_PUBLIC_CDN_URL` (no trailing slash).

const RAW = import.meta.env.VITE_PUBLIC_CDN_URL as string | undefined;

if (!RAW) {
  throw new Error(
    "VITE_PUBLIC_CDN_URL is not set. Add it to your environment (e.g. https://cdn.podgo.io).",
  );
}

export const PUBLIC_CDN_URL: string = RAW.replace(/\/+$/, "");

/**
 * Build a public CDN URL for an R2 object. URL-encodes each path segment
 * to match the historical behaviour of `r2PublicUrl()`.
 */
export function cdnUrl(bucket: string, path: string): string {
  const clean = path.replace(/^\/+/, "");
  const encoded = clean.split("/").map(encodeURIComponent).join("/");
  return `${PUBLIC_CDN_URL}/${bucket}/${encoded}`;
}
